/* תקופות. תקופה מזוהה במפתח YYYY-MM של החודש שבו היא מתחילה.
   כשתחילת החודש היא למשל 11: התקופה "2026-10" היא 11.10 עד 10.11. */
import { S } from './state.js';
import { MONTHS, fISO, todayISO } from '../lib/format.js';

export function monthStart() {
  return S.set.monthStart > 1 ? S.set.monthStart : 1;
}

/** התקופה שאליה שייך תאריך */
export function getKey(d) {
  const ms = monthStart();
  let year = d.getFullYear(), month = d.getMonth();
  if (ms > 1 && d.getDate() < ms) {
    if (month === 0) { year--; month = 11; } else month--;
  }
  return year + '-' + String(month + 1).padStart(2, '0');
}
export function keyOfISO(iso) {
  return getKey(new Date(String(iso).slice(0, 10) + 'T12:00:00'));
}
export function curKey() {
  return getKey(new Date());
}
export function keyAdd(k, n) {
  let y = parseInt(k.slice(0, 4), 10), m = parseInt(k.slice(5, 7), 10) - 1 + n;
  y += Math.floor(m / 12);
  m = ((m % 12) + 12) % 12;
  return y + '-' + String(m + 1).padStart(2, '0');
}
export function periodStart(k) {
  const y = parseInt(k.slice(0, 4), 10), m = parseInt(k.slice(5, 7), 10) - 1;
  return new Date(y, m, monthStart(), 12);
}
/** היום האחרון בתקופה */
export function periodEnd(k) {
  const y = parseInt(k.slice(0, 4), 10), m = parseInt(k.slice(5, 7), 10) - 1;
  const ms = monthStart();
  return ms > 1 ? new Date(y, m + 1, ms - 1, 12) : new Date(y, m + 1, 0, 12);
}
export function periodLength(k) {
  return Math.round((periodEnd(k) - periodStart(k)) / 864e5) + 1;
}

/** "11 אוקטובר – 10 נובמבר 2026" או "אוקטובר 2026" */
export function periodLabel(k) {
  const s = periodStart(k), e = periodEnd(k);
  if (monthStart() <= 1) return MONTHS[s.getMonth()] + ' ' + s.getFullYear();
  return s.getDate() + ' ' + MONTHS[s.getMonth()] + ' – ' + e.getDate() + ' ' + MONTHS[e.getMonth()] + ' ' + e.getFullYear();
}
/** "11.10-10.11" (קצר, לרשימות) */
export function periodShort(k) {
  const y = parseInt(k.slice(0, 4), 10), m = parseInt(k.slice(5, 7), 10) - 1;
  if (monthStart() <= 1) return MONTHS[m] + ' ' + y;
  const s = periodStart(k), e = periodEnd(k);
  return s.getDate() + '.' + (s.getMonth() + 1) + '-' + e.getDate() + '.' + (e.getMonth() + 1) +
    (e.getFullYear() !== new Date().getFullYear() ? ' ' + e.getFullYear() : '');
}
/** "אוק׳26" לטבלאות צפופות */
export function periodTiny(k) {
  const s = periodStart(k);
  return MONTHS[s.getMonth()].slice(0, 3) + "'" + String(s.getFullYear()).slice(2);
}

/** תאריך באותו מקום יחסי בתקופת היעד (15 בחודש נשאר 15) */
export function shiftDateToPeriod(iso, fromKey, toKey) {
  const d = new Date(String(iso || '').slice(0, 10) + 'T12:00:00');
  if (isNaN(d.getTime())) return fISO(periodStart(toKey));
  const n = Math.max(0, Math.round((d - periodStart(fromKey)) / 864e5));
  const ps = periodStart(toKey), pe = periodEnd(toKey);
  const t = new Date(ps.getFullYear(), ps.getMonth(), ps.getDate() + n, 12);
  return fISO(t > pe ? pe : t);
}

/** התקופות לבחירה: שנה אחורה ו-3 קדימה, ועוד מפתחות שחייבים להופיע */
export function periodOptions(extra) {
  const cur = curKey(), ks = [];
  for (let i = 3; i >= -12; i--) ks.push(keyAdd(cur, i));
  (extra || []).forEach((k) => { if (k && ks.indexOf(k) < 0) ks.push(k); });
  return ks.sort().reverse();
}

export function isToday(iso) {
  return String(iso).slice(0, 10) === todayISO();
}
